import { post, get } from '../utils/request'

export const login = post('/auth/login')
export const getTuociReqs = get('/req/getTuociReqs')
export const getMobiReqs = get('/req/getMobiReqs')
export const getJietuReqs = get('/req/getJietuReqs')
export const createTuociReq = post('/req/createTuociReq')
export const createMobiReq = post('/req/createMobiReq')
export const createJietuReq = post('/req/createJietuReq')